export default "__VITE_ASSET__79300cf5__"